import { util as sdkUtil } from '../util/sdkLoader';
import { denormalisedResponseEntities, ensureOwnListing, makeIntercomEventData } from '../util/data';
import * as log from '../util/log';
import { createTicketEventIDs, INTERCOM_EVENTS, LISTING_STATE_DRAFT, USER_TYPE_YOUTH, YOUTH_INVITE_STATUS } from '../util/types';
import { storableError } from '../util/errors';
import { isUserAuthorized } from '../util/userHelpers';
import { getAllTransitionsForEveryProcess, getTransitionsNeedingProviderAttention } from '../transactions/transaction';

import { authInfo } from './auth.duck';
import { stripeAccountCreateSuccess } from './stripeConnectAccount.duck';
import { fetchListOfSpacesbyEmail, onSendEventIntercom, onGetModeratorFindCollection, updateYouthAccountApi, onElephantTrustSignupCheck, fetchSpaceListApi, onCreateIntercomTicket, trackUserLoginApi, fetchTransactionsWithMetadata } from '../util/api';
import initializePendo from '../containers/LandingPage/PendoScript';
import moment from 'moment';
import { queryUserListings } from '../containers/ProfilePage/ProfilePage.duck';
import { updateProfile, updateUserInAlgolia } from '../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import { 
  // fetchCombineSpaceTopics, 
  fetchCommunityMember, onGetCircleAuthToken, successSpaceList } from '../containers/CircleCommunityPage/CircleCommunityPage.duck';
import { getChatHistories, getFavouriteChats } from '../containers/RuleBooksSearchPage/RuleBooksSearchPage.duck';

const currentUserGroupsRequests = new Map();

// ================ Action types ================ //

export const CURRENT_USER_SHOW_REQUEST = 'app/user/CURRENT_USER_SHOW_REQUEST';
export const CURRENT_USER_SHOW_SUCCESS = 'app/user/CURRENT_USER_SHOW_SUCCESS';
export const CURRENT_USER_SHOW_ERROR = 'app/user/CURRENT_USER_SHOW_ERROR';

export const CLEAR_CURRENT_USER = 'app/user/CLEAR_CURRENT_USER';

export const FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST =
  'app/user/FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST';
export const FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS =
  'app/user/FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS';
export const FETCH_CURRENT_USER_HAS_LISTINGS_ERROR =
  'app/user/FETCH_CURRENT_USER_HAS_LISTINGS_ERROR';

export const FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST';
export const FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS';
export const FETCH_CURRENT_USER_NOTIFICATIONS_ERROR =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_ERROR';

export const FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST_FOR_OFFER =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST_FOR_OFFER';
export const FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS_FOR_OFFER =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS_FOR_OFFER';
export const FETCH_CURRENT_USER_NOTIFICATIONS_ERROR_FOR_OFFER =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_ERROR_FOR_OFFER';

export const FETCH_CURRENT_USER_UNREAD_INQUIRIES_REQUEST =
  'app/user/FETCH_CURRENT_USER_UNREAD_INQUIRIES_REQUEST';
export const FETCH_CURRENT_USER_UNREAD_INQUIRIES_SUCCESS =
  'app/user/FETCH_CURRENT_USER_UNREAD_INQUIRIES_SUCCESS';
export const FETCH_CURRENT_USER_UNREAD_INQUIRIES_ERROR =
  'app/user/FETCH_CURRENT_USER_UNREAD_INQUIRIES_ERROR';

export const FETCH_CURRENT_USER_HAS_ORDERS_REQUEST =
  'app/user/FETCH_CURRENT_USER_HAS_ORDERS_REQUEST';
export const FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS =
  'app/user/FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS';
export const FETCH_CURRENT_USER_HAS_ORDERS_ERROR = 'app/user/FETCH_CURRENT_USER_HAS_ORDERS_ERROR';

export const SEND_VERIFICATION_EMAIL_REQUEST = 'app/user/SEND_VERIFICATION_EMAIL_REQUEST';
export const SEND_VERIFICATION_EMAIL_SUCCESS = 'app/user/SEND_VERIFICATION_EMAIL_SUCCESS';
export const SEND_VERIFICATION_EMAIL_ERROR = 'app/user/SEND_VERIFICATION_EMAIL_ERROR';

export const LANDING_PAGE_LISTING_REQUEST = 'app/user/LANDING_PAGE_LISTING_REQUEST';
export const LANDING_PAGE_LISTING_SUCCESS = 'app/user/LANDING_PAGE_LISTING_SUCCESS';
export const LANDING_PAGE_LISTING_ERROR = 'app/user/LANDING_PAGE_LISTING_ERROR';

export const FETCH_USER_MODERATORS_GROUPS_REQUEST = 'app/user/FETCH_USER_MODERATORS_GROUPS_REQUEST';
export const FETCH_USER_MODERATORS_GROUPS_SUCCESS = 'app/user/FETCH_USER_MODERATORS_GROUPS_SUCCESS';
export const FETCH_USER_MODERATORS_GROUPS_ERROR = 'app/user/FETCH_USER_MODERATORS_GROUPS_ERROR';

export const MARKETPLACE_COMING_SOON_REQUEST = 'app/user/MARKETPLACE_COMING_SOON_REQUEST';

export const SUBSCRIPTION_PERMISSION_REQUEST = 'app/user/SUBSCRIPTION_PERMISSION_REQUEST';

export const REQUEST_GROUP_PERMISSION_MODAL = 'app/user/REQUEST_GROUP_PERMISSION_MODAL';

export const RESTRICT_MARKETPLACE_REQUEST = 'app/user/RESTRICT_MARKETPLACE_REQUEST';

export const FETCH_CURRENT_USER_ALL_ORDERS_SUCCESS =
  'app/user/FETCH_CURRENT_USER_ALL_ORDERS_SUCCESS';

export const FETCH_CURRENT_USER_GROUPS_SUCCESS = 'app/user/FETCH_CURRENT_USER_GROUPS_SUCCESS';


// elephantVerificationModal
export const ELEPHANT_VERIFICATION_MODAL = 'app/user/ELEPHANT_VERIFICATION_MODAL';

export const ELEPHANT_VERIFICATION_REQUEST = 'app/user/ELEPHANT_VERIFICATION_REQUEST';
export const ELEPHANT_VERIFICATION_SUCCESS = 'app/user/ELEPHANT_VERIFICATION_SUCCESS';
export const ELEPHANT_VERIFICATION_ERROR = 'app/user/ELEPHANT_VERIFICATION_ERROR';

// Notification Modal
export const SET_NOTIFICATION_MODAL_OPEN = 'app/user/SET_NOTIFICATION_MODAL_OPEN';

export const FETCH_TOPBAR_GROUPS_REQUEST = 'app/user/FETCH_TOPBAR_GROUPS_REQUEST';
export const FETCH_TOPBAR_GROUPS_SUCCESS = 'app/user/FETCH_TOPBAR_GROUPS_SUCCESS';
export const FETCH_TOPBAR_GROUPS_ERROR = 'app/user/FETCH_TOPBAR_GROUPS_ERROR';

// ================ Reducer ================ //

const mergeCurrentUser = (oldCurrentUser, newCurrentUser) => {
  const { id: oId, type: oType, attributes: oAttr, ...oldRelationships } = oldCurrentUser || {};
  const { id, type, attributes, ...relationships } = newCurrentUser || {};

  // Passing null will remove currentUser entity.
  // Only relationships are merged.
  // TODO figure out if sparse fields handling needs a better handling.
  return newCurrentUser === null
    ? null
    : oldCurrentUser === null
      ? newCurrentUser
      : { id, type, attributes, ...oldRelationships, ...relationships };
};

const initialState = {
  currentUser: null,
  currentUserShowTimestamp: 0,
  currentUserShowError: null,
  currentUserHasListings: false,
  currentUserHasListingsError: null,
  currentUserNotificationCount: 0,
  currentUserNotificationCountForOffer: 0,
  currentUserNotificationCountError: null,
  currentUserNotificationCountErrorForOffer: null,
  currentUserUnreadInquiriesCount: 0,
  currentUserUnreadInquiriesError: null,
  currentUserHasOrders: null, // This is not fetched unless unverified emails exist
  currentUserHasOrdersError: null,
  sendVerificationEmailInProgress: false,
  sendVerificationEmailError: null,
  marketplaceCommingSoonRequest: false,
  restrictMarketplcaeRequest: false,
  subscriptionPermissionRequest: false,
  requestGroupPermissionModal: false,
  isAddAnItemPage: false,
  landingPageListingParams: null,
  landingPageListingRequest: false,
  landingPageListingError: null,
  landingPageListings: null,
  landingPagePagination: null,
  fetchAllOrdersLength: 0,
  fetchAllGroupsLength: 0,
  userModeratorsGroupsRequest: false,
  userModeratorsGroups: [],
  userModeratorsGroupsError: null,
  elephantVerificationModal: false,
  elephantVerificationInProgress: false,
  elephantVerificationError: null,

  // groups for topbar
  topbarGroups: null,
  topbarGroupsRequest: false,
  topbarGroupsError: null,

  // Notification Modal
  isOpenNotificationModal: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case CURRENT_USER_SHOW_REQUEST:
      return { ...state, currentUserShowError: null };
    case CURRENT_USER_SHOW_SUCCESS:
      return {
        ...state,
        currentUser: mergeCurrentUser(state.currentUser, payload),
        currentUserShowTimestamp: payload ? new Date().getTime() : 0,
      };
    case CURRENT_USER_SHOW_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, currentUserShowError: payload };

    case CLEAR_CURRENT_USER:
      return {
        ...state,
        currentUser: null,
        currentUserShowError: null,
        currentUserHasListings: false,
        currentUserHasListingsError: null,
        currentUserNotificationCount: 0,
        currentUserNotificationCountError: null,
        currentUserUnreadInquiriesCount: 0,
        currentUserUnreadInquiriesError: null,
      };

    case FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST:
      return { ...state, currentUserHasListingsError: null };
    case FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS:
      return { ...state, currentUserHasListings: payload.hasListings };
    case FETCH_CURRENT_USER_HAS_LISTINGS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, currentUserHasListingsError: payload };

    case FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST:
      return { ...state, currentUserNotificationCountError: null };
    case FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS:
      return { ...state, currentUserNotificationCount: payload.transactions.length };
    case FETCH_CURRENT_USER_NOTIFICATIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, currentUserNotificationCountError: payload };

    case FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST_FOR_OFFER:
      return { ...state, currentUserNotificationCountErrorForOffer: null };
    case FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS_FOR_OFFER:
      return { ...state, currentUserNotificationCountForOffer: payload.transactions.length };
    case FETCH_CURRENT_USER_NOTIFICATIONS_ERROR_FOR_OFFER:
      console.error(payload); // eslint-disable-line
      return { ...state, currentUserNotificationCountErrorForOffer: payload };

    case FETCH_CURRENT_USER_UNREAD_INQUIRIES_REQUEST:
      return { ...state, currentUserUnreadInquiriesError: null };
    case FETCH_CURRENT_USER_UNREAD_INQUIRIES_SUCCESS:
      return { ...state, currentUserUnreadInquiriesCount: payload.count };
    case FETCH_CURRENT_USER_UNREAD_INQUIRIES_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, currentUserUnreadInquiriesError: payload };

    case FETCH_CURRENT_USER_HAS_ORDERS_REQUEST:
      return { ...state, currentUserHasOrdersError: null };
    case FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS:
      return { ...state, currentUserHasOrders: payload.hasOrders };
    case FETCH_CURRENT_USER_HAS_ORDERS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, currentUserHasOrdersError: payload };

    case SEND_VERIFICATION_EMAIL_REQUEST:
      return {
        ...state,
        sendVerificationEmailInProgress: true,
        sendVerificationEmailError: null,
      };
    case SEND_VERIFICATION_EMAIL_SUCCESS:
      return {
        ...state,
        sendVerificationEmailInProgress: false,
      };
    case SEND_VERIFICATION_EMAIL_ERROR:
      return {
        ...state,
        sendVerificationEmailInProgress: false,
        sendVerificationEmailError: payload,
      };

    case MARKETPLACE_COMING_SOON_REQUEST:
      return {
        ...state,
        marketplaceCommingSoonRequest: !!(payload)
      }

    case SUBSCRIPTION_PERMISSION_REQUEST:
      return {
        ...state,
        subscriptionPermissionRequest: !!(payload.type),
        isAddAnItemPage: payload.isAddAnItemPage
      }

    case REQUEST_GROUP_PERMISSION_MODAL:
      return {
        ...state,
        requestGroupPermissionModal: !!payload
      }

    case RESTRICT_MARKETPLACE_REQUEST:
      return {
        ...state,
        restrictMarketplcaeRequest: !!payload
      }

    case FETCH_CURRENT_USER_ALL_ORDERS_SUCCESS:
      return { ...state, fetchAllOrdersLength: payload };

    case FETCH_CURRENT_USER_GROUPS_SUCCESS:
      return { ...state, fetchAllGroupsLength: payload };

    case LANDING_PAGE_LISTING_REQUEST:
      return {
        ...state,
        landingPageListingParams: null,
        landingPageListingRequest: true,
        landingPageListingError: null,
        landingPageListings: null,
      };
    case LANDING_PAGE_LISTING_SUCCESS:
      return {
        ...state,
        landingPageListingParams: payload.params,
        landingPageListingRequest: false,
        landingPageListingError: null,
        landingPageListings: payload.data,
        landingPagePagination: payload.landingPagePagination,
      };
    case LANDING_PAGE_LISTING_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        landingPageListingParams: null,
        landingPageListingRequest: false,
        landingPageListingError: true,
        landingPageListings: null,
      };

    case FETCH_USER_MODERATORS_GROUPS_REQUEST:
      return {
        ...state,
        userModeratorsGroupsRequest: true,
        userModeratorsGroups: [],
        userModeratorsGroupsError: null
      };
    case FETCH_USER_MODERATORS_GROUPS_SUCCESS:
      return {
        ...state,
        userModeratorsGroupsRequest: false,
        userModeratorsGroups: payload.data,
        userModeratorsGroupsError: null,
      };
    case FETCH_USER_MODERATORS_GROUPS_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        userModeratorsGroupsRequest: false,
        userModeratorsGroups: [],
        userModeratorsGroupsError: payload,
      };


    case ELEPHANT_VERIFICATION_MODAL:
      return {
        ...state,
        elephantVerificationModal: !!payload
      }

    case ELEPHANT_VERIFICATION_REQUEST:
      return {
        ...state,
        elephantVerificationInProgress: true,
        elephantVerificationError: null,
      };
    case ELEPHANT_VERIFICATION_SUCCESS:
      return {
        ...state,
        elephantVerificationInProgress: false,
        elephantVerificationError: null,
      };
    case ELEPHANT_VERIFICATION_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        elephantVerificationInProgress: false,
        elephantVerificationError: payload,
      };


    case FETCH_TOPBAR_GROUPS_REQUEST:
      return {
        ...state,
        topbarGroups: null,
        topbarGroupsRequest: true,
        topbarGroupsError: null,
      };
    case FETCH_TOPBAR_GROUPS_SUCCESS:
      return {
        ...state,
        topbarGroups: payload,
        topbarGroupsRequest: false,
        topbarGroupsError: null,
      };
    case FETCH_TOPBAR_GROUPS_ERROR:
      console.error(payload); // eslint-disable-line
      return {
        ...state,
        topbarGroups: null,
        topbarGroupsRequest: false,
        topbarGroupsError: payload,
      };

    case SET_NOTIFICATION_MODAL_OPEN:
      return {
        ...state,
        isOpenNotificationModal: !!payload,
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const hasCurrentUserErrors = state => {
  const { user } = state;
  return (
    user.currentUserShowError ||
    user.currentUserHasListingsError ||
    user.currentUserNotificationCountError ||
    user.currentUserHasOrdersError
  );
};

export const verificationSendingInProgress = state => {
  return state.user.sendVerificationEmailInProgress;
};

// ================ Action creators ================ //

export const currentUserShowRequest = () => ({ type: CURRENT_USER_SHOW_REQUEST });

export const marketplaceCommingSoonRequest = (type) => ({
  type: MARKETPLACE_COMING_SOON_REQUEST,
  payload: type,
});

export const restrictMarketplcaeRequest = (type) => ({
  type: RESTRICT_MARKETPLACE_REQUEST,
  payload: type,
});

export const subscriptionPermissionRequest = (type, isAddAnItemPage = false) => ({
  type: SUBSCRIPTION_PERMISSION_REQUEST,
  payload: { type, isAddAnItemPage },
});

export const requestGroupPermissionModal = (type) => ({
  type: REQUEST_GROUP_PERMISSION_MODAL,
  payload: type,
});


export const currentUserShowSuccess = user => ({
  type: CURRENT_USER_SHOW_SUCCESS,
  payload: user,
});

export const currentUserShowError = e => ({
  type: CURRENT_USER_SHOW_ERROR,
  payload: e,
  error: true,
});

export const clearCurrentUser = () => ({ type: CLEAR_CURRENT_USER });

const fetchCurrentUserHasListingsRequest = () => ({
  type: FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST,
});

export const fetchCurrentUserHasListingsSuccess = hasListings => ({
  type: FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS,
  payload: { hasListings },
});

const fetchCurrentUserHasListingsError = e => ({
  type: FETCH_CURRENT_USER_HAS_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const fetchCurrentUserNotificationsRequest = () => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST,
});

export const fetchCurrentUserNotificationsSuccess = transactions => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS,
  payload: { transactions },
});

const fetchCurrentUserNotificationsError = e => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_ERROR,
  error: true,
  payload: e,
});

export const fetchCurrentUserNotificationsRequestForOffers = () => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST_FOR_OFFER,
});

export const fetchCurrentUserNotificationsSuccessForOffers = transactions => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS_FOR_OFFER,
  payload: { transactions },
});

const fetchCurrentUserNotificationsErrorForOffers = e => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_ERROR_FOR_OFFER,
  error: true,
  payload: e,
});

export const fetchCurrentUserUnreadInquiriesRequest = () => ({
  type: FETCH_CURRENT_USER_UNREAD_INQUIRIES_REQUEST,
});

export const fetchCurrentUserUnreadInquiriesSuccess = count => ({
  type: FETCH_CURRENT_USER_UNREAD_INQUIRIES_SUCCESS,
  payload: { count },
});

const fetchCurrentUserUnreadInquiriesError = e => ({
  type: FETCH_CURRENT_USER_UNREAD_INQUIRIES_ERROR,
  error: true,
  payload: e,
});

const fetchCurrentUserHasOrdersRequest = () => ({
  type: FETCH_CURRENT_USER_HAS_ORDERS_REQUEST,
});

export const fetchCurrentUserHasOrdersSuccess = hasOrders => ({
  type: FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS,
  payload: { hasOrders },
});

const fetchCurrentUserHasOrdersError = e => ({
  type: FETCH_CURRENT_USER_HAS_ORDERS_ERROR,
  error: true,
  payload: e,
});

export const sendVerificationEmailRequest = () => ({
  type: SEND_VERIFICATION_EMAIL_REQUEST,
});

export const sendVerificationEmailSuccess = () => ({
  type: SEND_VERIFICATION_EMAIL_SUCCESS,
});

export const sendVerificationEmailError = e => ({
  type: SEND_VERIFICATION_EMAIL_ERROR,
  error: true,
  payload: e,
});

export const fetchCurrentUserAllOrdersSuccess = data => ({
  type: FETCH_CURRENT_USER_ALL_ORDERS_SUCCESS,
  payload: data,
});

export const fetchCurrentUserAllGroupsSuccess = data => ({
  type: FETCH_CURRENT_USER_GROUPS_SUCCESS,
  payload: data,
});


export const landingPageListingRequest = () => ({
  type: LANDING_PAGE_LISTING_REQUEST,
});

export const landingPageListingsSuccess = (response) => ({
  type: LANDING_PAGE_LISTING_SUCCESS,
  payload: response,
});

export const landingPageListingError = e => ({
  type: LANDING_PAGE_LISTING_ERROR,
  error: true,
  payload: e,
});

export const fetchUserModeratorsGroupsRequest = () => ({
  type: FETCH_USER_MODERATORS_GROUPS_REQUEST,
});

export const fetchUserModeratorsGroupsSuccess = (response) => ({
  type: FETCH_USER_MODERATORS_GROUPS_SUCCESS,
  payload: response,
});

export const fetchUserModeratorsGroupError = e => ({
  type: FETCH_USER_MODERATORS_GROUPS_ERROR,
  payload: e,
});


export const setElephantVerificationModal = data => ({
  type: ELEPHANT_VERIFICATION_MODAL,
  payload: data,
});

export const elephantVerificationRequest = () => ({
  type: ELEPHANT_VERIFICATION_REQUEST,
});

export const elephantVerificationSuccess = () => ({
  type: ELEPHANT_VERIFICATION_SUCCESS,
});

export const elephantVerificationError = (payload) => ({
  type: ELEPHANT_VERIFICATION_ERROR,
  payload: payload
});



export const fetchTopbarGroupsRequest = () => ({
  type: FETCH_TOPBAR_GROUPS_REQUEST,
});

export const fetchTopbarGroupsSuccess = (data) => ({
  type: FETCH_TOPBAR_GROUPS_SUCCESS,
  payload: data
});

export const fetchTopbarGroupsError = (error) => ({
  type: FETCH_TOPBAR_GROUPS_ERROR,
  payload: error
});

export const setNotificationModalOpen = (isOpen) => ({
  type: SET_NOTIFICATION_MODAL_OPEN,
  payload: isOpen,
});


// ================ Thunks ================ //
export const fetchLandingPageListings = (params) => (dispatch, getState, sdk) => {
  dispatch(landingPageListingRequest());
  return sdk.listings
    .query(params)
    .then(response => {
      dispatch(landingPageListingsSuccess({
        data: response.data.data,
        params: params,
        landingPagePagination: response.data.meta,
      }));
      return response
    })
    .catch(e => dispatch(landingPageListingError(storableError(e))));
};

export const fetchCurrentUserGroups = (params = {}) => (dispatch, getState, sdk) => {
  const { forceRefresh = false } = params || {};
  const { currentUser } = getState().user;

  if (!currentUser) {
    dispatch(fetchCurrentUserAllGroupsSuccess(false));
    return Promise.resolve(null);
  }
  const { email } = currentUser.attributes || {};
  const cacheKey = (email || '').trim().toLowerCase();

  if (!cacheKey) {
    dispatch(fetchCurrentUserAllGroupsSuccess(false));
    return Promise.resolve(0);
  }

  if (!forceRefresh && currentUserGroupsRequests.has(cacheKey)) {
    return currentUserGroupsRequests.get(cacheKey);
  }

  const request = fetchListOfSpacesbyEmail({ email, forceRefresh })
    .then(response => {
      if (response && response.length > 0) {

        const allUserGroupIds = response?.filter(({ is_member }) => is_member).length || 0
        dispatch(fetchCurrentUserAllGroupsSuccess(allUserGroupIds))
        return allUserGroupIds;
      } else {
        return 0;
      }
    })
    .catch(e => dispatch(fetchCurrentUserHasListingsError(storableError(e))))
    .finally(() => {
      currentUserGroupsRequests.delete(cacheKey);
    });

  if (!forceRefresh) {
    currentUserGroupsRequests.set(cacheKey, request);
  }
  return request;
};

export const fetchCurrentUserHasListings = () => (dispatch, getState, sdk) => {
  dispatch(fetchCurrentUserHasListingsRequest());
  const { currentUser } = getState().user;

  if (!currentUser) {
    dispatch(fetchCurrentUserHasListingsSuccess(false));
    return Promise.resolve(null);
  }

  const params = {
    // Since we are only interested in if the user has published
    // listings, we only need at most one result.
    states: 'published',
    page: 1,
    perPage: 1,
  };

  return sdk.ownListings
    .query(params)
    .then(response => {
      const hasListings = response.data.data && response.data.data.length > 0;

      const hasPublishedListings =
        hasListings &&
        ensureOwnListing(response.data.data[0]).attributes.state !== LISTING_STATE_DRAFT;
      dispatch(fetchCurrentUserHasListingsSuccess(!!hasPublishedListings));
    })
    .catch(e => dispatch(fetchCurrentUserHasListingsError(storableError(e))));
};

export const fetchCurrentUserHasOrders = () => (dispatch, getState, sdk) => {
  dispatch(fetchCurrentUserHasOrdersRequest());

  if (!getState().user.currentUser) {
    dispatch(fetchCurrentUserHasOrdersSuccess(false));
    return Promise.resolve(null);
  }

  const params = {
    only: 'order',
    page: 1,
    perPage: 1,
  };

  return sdk.transactions
    .query(params)
    .then(response => {
      const hasOrders = response.data.data && response.data.data.length > 0;
      dispatch(fetchCurrentUserHasOrdersSuccess(!!hasOrders));
    })
    .catch(e => dispatch(fetchCurrentUserHasOrdersError(storableError(e))));
};

export const fetchAllUserTransactions = () => async (dispatch, getState, sdk) => {
  dispatch(fetchCurrentUserHasOrdersRequest());

  if (!getState().user.currentUser) {
    dispatch(fetchCurrentUserAllOrdersSuccess(0));
    return Promise.resolve([]);
  }

  const offerTransactions = [
    "transition/cancel-offer-customer",
    "transition/cancel-offer-provider",
    "transition/expire-offer-payment",
    'transition/auto-cancel',
    'transition/cancel',
    'transition/cancel-by-provider',
  ];

  const params = {
    only: "order",
    perPage: 50, // Fetching more transactions per request
    lastTransitions: getAllTransitionsForEveryProcess().filter((st) => !offerTransactions.includes(st)),
  };

  try {
    // Fetch the first page to determine total transaction count
    const firstResponse = await sdk.transactions.query({ ...params, page: 1 });
    const totalCount = firstResponse.data.meta.totalItems;

    if (totalCount === 0) {
      dispatch(fetchCurrentUserAllOrdersSuccess(0));
      return [];
    }

    const totalPages = Math.ceil(totalCount / params.perPage);

    // Generate an array of promises for fetching all pages in parallel
    const fetchPromises = Array.from({ length: totalPages }, (_, index) =>
      sdk.transactions.query({ ...params, page: index + 1 })
    );

    // Fetch all pages concurrently
    const responses = await Promise.all(fetchPromises);

    // Extract transactions from all responses
    const allTransactions = responses.flatMap(response => response.data.data);
    dispatch(fetchCurrentUserAllOrdersSuccess(allTransactions.length));
    return allTransactions;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    dispatch(fetchCurrentUserHasOrdersError(storableError(error)));
    return [];
  }
};

// Notificaiton page size is max (100 items on page)
const NOTIFICATION_PAGE_SIZE = 100;

export const fetchCurrentUserNotifications = () => (dispatch, getState, sdk) => {
  const transitionsNeedingAttention = getTransitionsNeedingProviderAttention().filter((st) => st != "transition/confirm-offer-payment");
  if (transitionsNeedingAttention.length === 0) {
    // Don't update state, if there's no need to draw user's attention after last transitions.
    return;
  }

  const apiQueryParams = {
    only: 'sale',
    lastTransitions: transitionsNeedingAttention,
    page: 1,
    perPage: NOTIFICATION_PAGE_SIZE,
  };

  dispatch(fetchCurrentUserNotificationsRequest());
  return sdk.transactions
    .query(apiQueryParams)
    .then(response => {
      const transactions = response.data.data;
      dispatch(fetchCurrentUserNotificationsSuccess(transactions));
    })
    .catch(e => dispatch(fetchCurrentUserNotificationsError(storableError(e))));
};

export const fetchCurrentUserNotificationsForOffers = () => (dispatch, getState, sdk) => {
  const transitionsNeedingAttention = getTransitionsNeedingProviderAttention();
  if (transitionsNeedingAttention.length === 0) {
    // Don't update state, if there's no need to draw user's attention after last transitions.
    return;
  }
  const apiQueryParams = {
    lastTransitions: ["transition/confirm-offer-payment"],
    page: 1,
    only: 'sale',
    perPage: NOTIFICATION_PAGE_SIZE,
  };

  dispatch(fetchCurrentUserNotificationsRequestForOffers());
  return sdk.transactions
    .query(apiQueryParams)
    .then(response => {
      const transactions = response.data.data;
      dispatch(fetchCurrentUserNotificationsSuccessForOffers(transactions));
    })
    .catch(e => dispatch(fetchCurrentUserNotificationsErrorForOffers(storableError(e))));
};

/**
 * Fetch unread inquiry messages count
 * This checks transactions with 'transition/inquire' or 'transition/inquire-without-payment'
 * and counts those where the current user has unread messages
 */
export const fetchCurrentUserUnreadInquiries = () => (dispatch, getState, sdk) => {
  const { currentUser } = getState().user;

  if (!currentUser) {
    dispatch(fetchCurrentUserUnreadInquiriesSuccess(0));
    return Promise.resolve(null);
  }

  dispatch(fetchCurrentUserUnreadInquiriesRequest());

  const userId = currentUser.id.uuid;

  // Fetch all inquiry transactions using Integration API (via server endpoint)
  // This returns transactions with metadata which includes lastMessageDetails
  return fetchTransactionsWithMetadata(userId, 'all')
    .then(response => {
      const transactions = response.transactions || [];

      // Count unread messages by filtering transactions where current user has unread messages
      let unreadCount = 0;

      transactions.forEach(tx => {
        const customerId = tx.relationships?.customer?.data?.id?.uuid;
        const providerId = tx.relationships?.provider?.data?.id?.uuid;
        const metadata = tx.attributes?.metadata || {};
        const lastMessageDetails = metadata.lastMessageDetails || {};

        // Check if there's a last message
        if (lastMessageDetails?.lastMessageSenderId) {
          const senderId = lastMessageDetails.lastMessageSenderId;
          const isReadByOtherParty = lastMessageDetails.lastMessageReadByOtherParty;

          // If current user is the customer (buyer)
          if (customerId === userId) {
            // Count as unread if message was sent by provider and not read by customer (other party)
            if (senderId === providerId && !isReadByOtherParty) {
              unreadCount++;
            }
          }
          // If current user is the provider (seller)
          else if (providerId === userId) {
            // Count as unread if message was sent by customer and not read by provider (other party)
            if (senderId === customerId && !isReadByOtherParty) {
              unreadCount++;
            }
          }
        }
      });

      dispatch(fetchCurrentUserUnreadInquiriesSuccess(unreadCount));
      return unreadCount;
    })
    .catch(e => {
      console.error('Error fetching unread inquiries:', e);
      dispatch(fetchCurrentUserUnreadInquiriesError(storableError(e)));
    });
};


export const fetchUserModeratorsGroups = (params) => (dispatch, getState, sdk) => {
  dispatch(fetchUserModeratorsGroupsRequest());
  // Add your API call here to fetch moderators
  return onGetModeratorFindCollection(params)
    .then(response => {
      dispatch(fetchUserModeratorsGroupsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchUserModeratorsGroupError(e.message));
      return e.message;
    });
};

export const collectClientFingerprint = async () => {
  if (typeof window == "undefined") return {};

  const navigatorInfo = window.navigator || {};
  const screenInfo = window.screen || {};

  // Detect incognito mode (best-effort)
  const isIncognito = await (async () => {
    try {
      const fs = window.RequestFileSystem || window.webkitRequestFileSystem;
      if (!fs) return false;
      return new Promise(resolve => {
        fs(window.TEMPORARY, 100, () => resolve(false), () => resolve(true));
      });
    } catch {
      return false;
    }
  })();

  // Canvas fingerprint (hashed)
  const getCanvasFingerprint = () => {
    try {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      ctx.textBaseline = "top";
      ctx.font = "14px Arial";
      ctx.fillText("ElephantTrust", 2, 2);
      const data = canvas.toDataURL();
      let hash = 0;
      for (let i = 0; i < data.length; i++) {
        const char = data.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0;
      }
      return hash.toString();
    } catch {
      return null;
    }
  };

  // WebGL GPU info
  const getWebGLInfo = () => {
    try {
      const canvas = document.createElement("canvas");
      const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
      if (!gl) return {};
      const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
      return {
        gpuName: debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : '',
        gpuVendor: debugInfo ? gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) : '',
      };
    } catch {
      return { gpuName: '', gpuVendor: '' };
    }
  };

  // Persistent storage check
  const hasPersistentStorage = await (async () => {
    try {
      if (navigator.storage?.persisted) {
        return await navigator.storage.persisted();
      }
      return false;
    } catch {
      return false;
    }
  })();

  // Battery level (fallback-safe)
  const batteryLevel = await (async () => {
    try {
      const battery = await navigator.getBattery?.();
      return battery ? battery.level * 100 : null;
    } catch {
      return null;
    }
  })();

  const webGLInfo = getWebGLInfo();

  return {
    language: navigatorInfo.language || '',
    os: navigatorInfo.platform || '',
    osVersion: navigator.userAgentData?.platformVersion || '',
    device: /Mobile|Android/i.test(navigatorInfo.userAgent) ? 'mobile' : 'desktop',
    screenResolution: `${screenInfo.width}x${screenInfo.height}`,
    timezoneOffset: new Date().getTimezoneOffset(),
    isIncognito,
    isEmulator: false,
    isVirtualEnv: navigatorInfo.webdriver || false,
    canvas: getCanvasFingerprint(),
    userAgent: navigatorInfo.userAgent || '',
    memory: navigator.deviceMemory || null,
    hardwareConcurrency: navigator.hardwareConcurrency || null,
    gpuName: webGLInfo.gpuName,
    gpuVendor: webGLInfo.gpuVendor,
    hasPersistentStorage,
    batteryLevel,
    source: document.referrer ? new URL(document.referrer).hostname : 'direct',
    campaignId: new URLSearchParams(window.location.search).get('campaign_id') || '',
    campaignName: new URLSearchParams(window.location.search).get('campaign_name') || '',
  };
}

export const fetchCurrentUser = (options, guardianInvite) => (dispatch, getState, sdk) => {
  const state = getState();
  const { currentUserHasListings, currentUserShowTimestamp } = state.user || {};
  const { isAuthenticated } = state.auth;
  const {
    callParams = null,
    updateHasListings = true,
    updateNotifications = true,
    afterLogin,
    enforce = false, // Automatic emailVerification might be called too fast
  } = options || {};

  // Double fetch might happen when e.g. profile page is making a full page load
  const aSecondAgo = new Date().getTime() - 1000;
  if (!enforce && currentUserShowTimestamp > aSecondAgo) {
    return Promise.resolve({});
  }
  // Set in-progress, no errors
  dispatch(currentUserShowRequest());

  if (!isAuthenticated && !afterLogin) {
    // Make sure current user is null
    dispatch(currentUserShowSuccess(null));
    return Promise.resolve({});
  }

  const parameters = callParams || {
    include: ['effectivePermissionSet', 'profileImage', 'stripeAccount'],
    'fields.image': [
      'variants.square-small',
      'variants.square-small2x',
      'variants.square-xsmall',
      'variants.square-xsmall2x',
    ],
    'imageVariant.square-xsmall': sdkUtil.objectQueryString({
      w: 40,
      h: 40,
      fit: 'crop',
    }),
    'imageVariant.square-xsmall2x': sdkUtil.objectQueryString({
      w: 80,
      h: 80,
      fit: 'crop',
    }),
  };

  return sdk.currentUser
    .show(parameters)
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the sdk.currentUser.show response');
      }
      const currentUser = entities[0];
      if (guardianInvite?.invite_id) {
        try {
          const filter = {
            invite_id: guardianInvite.invite_id,
          }
          const payload = {
            youth_id: currentUser.id.uuid,
            youth_status: YOUTH_INVITE_STATUS.ACCEPT,
          }
          updateYouthAccountApi({ filter, payload })
        } catch (error) {
          console.error(error, "pendo initialize");
        }

      }

      // Save stripeAccount to store.stripe.stripeAccount if it exists
      if (currentUser.stripeAccount) {
        dispatch(stripeAccountCreateSuccess(currentUser.stripeAccount));
      }


      try {
        dispatch(fetchUserModeratorsGroups({
          payload: {
            userId: currentUser.id.uuid,
            status: "active",
          },
          pageParams: {
            page: 1,
            perPage: 100
          }
        }));
      } catch (e) {
        console.log(e, '&&& &&& => e');
      }

      // redirectToCircleApi({ user });
      // set current user id to the logger
      log.setUserId(currentUser.id.uuid);
      dispatch(currentUserShowSuccess(currentUser));

      // Track login activity for badge progress (non-blocking)
      try {
        trackUserLoginApi({ userId: currentUser.id.uuid }).catch(err => {
          console.log('[Badge System] Login tracking failed (non-critical):', err);
        });
      } catch (e) {
        // Silent fail - badge tracking shouldn't block login
      }

      return currentUser;
    })
    .then(currentUser => {
      // If currentUser is not active (e.g. in 'pending-approval' state),
      // then they don't have listings or transactions that we care about.
      if (isUserAuthorized(currentUser)) {
        if (currentUserHasListings === false && updateHasListings !== false) {
          dispatch(fetchCurrentUserHasListings());
        }

        if (updateNotifications !== false) {
          dispatch(fetchCurrentUserNotifications());
          dispatch(fetchCurrentUserNotificationsForOffers());
          dispatch(fetchCurrentUserUnreadInquiries());
        }
        if (!currentUser.attributes.emailVerified) {
          dispatch(fetchCurrentUserHasOrders());
        }
      }

      // isFirstLogin || guardianInvite?.isFirstLogin
      if (guardianInvite?.isFirstLogin) {

        // create ticket in intercom
        const createElephantFailTicket = () => {
          try {
            const intercomElephantData = {
              userName: `${currentUser?.attributes?.profile?.firstName || ""} ${currentUser?.attributes?.profile?.lastName || ""}`.trim(),
              userEmail: currentUser?.attributes?.email || "",
              userId: currentUser?.id?.uuid || ""
            };

            const createTicketData = {
              ticketTypeId: createTicketEventIDs["Elephant Fails"],
              attributes: intercomElephantData,
              assignment: true
            };

            onCreateIntercomTicket(createTicketData)
              .then(res => {
                console.log("✅ Intercom ticket created successfully", res);
              })
              .catch(err => {
                console.error("❌ Error creating Intercom ticket", err);
              });
          } catch (err) {
            console.error("❌ Error preparing Intercom ticket data", err);
          }
        };

        try {
          collectClientFingerprint()
            .then(fingerprint => {
              const userRole = currentUser?.attributes?.profile?.publicData?.userRole;
              if (userRole != USER_TYPE_YOUTH)
                onElephantTrustSignupCheck({
                  userId: currentUser.id.uuid,
                  clientFingerprint: fingerprint,
                  type: 'signup',
                });
            })
            .then(res => {
              if (res?.decision) {
                // Update user in Algolia using existing flow
                // We reuse the same thunk used after profile updates
                // to ensure consistent indexing structure.
                try {
                  // No specific actionPayload changes here; pass empty overrides
                  // since we only need to upsert the current user snapshot.
                  dispatch(updateUserInAlgolia(currentUser?.id?.uuid, {}));
                } catch (algoliaErr) {
                  console.error('❌ Error dispatching Algolia user update', algoliaErr);
                }
              }
              // ✅ Elephant Trust check passed — do nothing
            })
            .catch(err => {
              console.error('❌ Elephant Trust check failed', err);
              createElephantFailTicket();
            });
        } catch (err) {
          console.error("❌ Unexpected error in Elephant Trust check", err);
          createElephantFailTicket();
        }
      };

      // Data fetching for topbar Mobile navigations
      try {
        const promisifyUserData = [];
        // topbar menu fetch community member
        promisifyUserData.push(dispatch(fetchCommunityMember()));
        // topbar menu fetch user groups
        promisifyUserData.push(dispatch(fetchTopbarGroups({ forceRefresh: true })));
        // ai topbar menu fetch chat history
        promisifyUserData.push(dispatch(getChatHistories()));
        // ai topbar menu fetch favourite rulebooks
        promisifyUserData.push(dispatch(getFavouriteChats()));

        Promise.all(promisifyUserData)
          .then(() => {
            console.log('Topbar groups fetched successfully', '&&& &&& => ');
          });
      } catch (error) {
        console.error(error, " Data fetching ERROR");
      };

      // Make sure auth info is up to date
      dispatch(authInfo());
      return currentUser;
    })
    .catch(e => {
      // Make sure auth info is up to date
      dispatch(authInfo());
      log.error(e, 'fetch-current-user-failed');
      dispatch(currentUserShowError(storableError(e)));
    });
};

export const updatedVisitorData = (config) => async (dispatch, getState, sdk) => {
  try {
    await dispatch(fetchCurrentUser());
    const state = getState();
    const { currentUser } = state.user || {};

    if (!currentUser?.id) return;
    const visitorId = currentUser.id.uuid || '';
    const { email, profile, createdAt } = currentUser.attributes || {};
    const { firstName, publicData } = profile || {};
    const { selectedState } = publicData?.shippingAddress?.selectedPlace || publicData?.pickupAddress?.selectedPlace || {};
    return Promise.all([
      dispatch(queryUserListings(visitorId, config)),
      dispatch(fetchAllUserTransactions()),
      dispatch(fetchCurrentUserGroups({ forceRefresh: true })),
    ]).then((res) => {
      const state = getState();
      const { userListingRefs = [] } = state.ProfilePage || {};
      const { fetchAllOrdersLength = 0, fetchAllGroupsLength = 0 } = state.user || {};

      const visitorData = {
        email,
        firstName,
        signupDate: moment(createdAt).format("DD/MM/yyyy"),
        state: selectedState || "N/A",
        joinedCommunityGroups: fetchAllGroupsLength,
        listingsCount: userListingRefs?.length || 0,
        purchasesCount: fetchAllOrdersLength,
      };
      return initializePendo(visitorId, visitorData);
    });

  } catch (error) {
    console.error(error, "pendo initialize");
    return {};
  }
};

export const sendVerificationEmail = () => (dispatch, getState, sdk) => {
  if (verificationSendingInProgress(getState())) {
    return Promise.reject(new Error('Verification email sending already in progress'));
  }
  dispatch(sendVerificationEmailRequest());
  return sdk.currentUser
    .sendVerificationEmail()
    .then(() => dispatch(sendVerificationEmailSuccess()))
    .catch(e => dispatch(sendVerificationEmailError(storableError(e))));
};


export const reevaluateElephantVerification = (values) => async (dispatch, getState, sdk) => {
  try {
    dispatch(elephantVerificationRequest());

    const shouldUpdateProfileFirst = values && Object.keys(values).length > 0;
    const currentUser = shouldUpdateProfileFirst
      ? await dispatch(updateProfile(values))
      : getState()?.user?.currentUser || (await dispatch(fetchCurrentUser()));
    const userId = currentUser?.id?.uuid;

    if (!userId) {
      throw new Error('Current user is missing for Elephant re-evaluation');
    }

    const fingerprint = await collectClientFingerprint();
    const res = await onElephantTrustSignupCheck({
      userId: userId,
      clientFingerprint: fingerprint,
      type: "user-reevaluation"
    });
    const reevaluationValues = {
      privateData: {
        reevaluationElephantScore: res.score,
        reevaluationElephantDecision: res.decision,
      }
    };
    await dispatch(updateProfile(reevaluationValues));
    dispatch(elephantVerificationSuccess());
    return res;
  }
  catch (e) {
    console.log(e, '&&& &&& => e');
    dispatch(elephantVerificationError(storableError(e)))
  }
};


export const fetchTopbarGroups = (params = {}) => async (dispatch, getState, sdk) => {
  try {
    const { forceRefresh = false } = params || {};
    const currentUser = getState()?.user?.currentUser;
    const email = currentUser?.attributes?.email;
    const { circleEmail } = currentUser?.attributes?.profile?.privateData || {};
    const { topbarGroups, topbarGroupsRequest } = getState()?.user || {};
    const { spaceListData } = getState()?.CircleCommunityPage || {};

    if (!forceRefresh && Array.isArray(topbarGroups) && topbarGroups.length > 0) {
      if (!Array.isArray(spaceListData) || spaceListData.length === 0) {
        dispatch(successSpaceList(topbarGroups));
        // dispatch(fetchCombineSpaceTopics({}));
      }
      return topbarGroups;
    }

    if (!forceRefresh && topbarGroupsRequest) {
      return topbarGroups || [];
    }

    const { access_token } = await onGetCircleAuthToken({
      email: circleEmail || email,
    });
    if (!email) {
      return Promise.resolve([]);
    };
    dispatch(fetchTopbarGroupsRequest());
    const response = await fetchSpaceListApi({ accessToken: access_token, forceRefresh });
    dispatch(fetchTopbarGroupsSuccess(response));
    dispatch(successSpaceList(response));
    // dispatch(fetchCombineSpaceTopics({}));
    return response;
  } catch (error) {
    console.error(error, "pendo initialize");
    dispatch(fetchTopbarGroupsError(storableError(error)));
  }
};
export const shopifyDataSelector = state =>
  (() => {
    const publicData = state.user.currentUser?.attributes?.profile?.publicData || {};
    return {
      shopifyId: publicData?.shopifyId ?? null,
      myShopifyDomain: publicData?.myShopifyDomain ?? null,
      shopifyStatus: publicData?.shopifyStatus ?? null,
      shopifyIsConnected: publicData?.shopifyStatus === 'CONNECTED',
    };
  })();
